import { string, shape, any } from "prop-types";
import * as colors from "../styles/colors";
import * as libraryNames from "../enums/libraryNames";

export const imageProps = shape({
	src: any,
	alt: string,
});
const fontFamilyDefaults = `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`;
export const fontFamilyInter = `'Inter', ${fontFamilyDefaults}`;
export const borderRadiusXS = "2px";
export const borderRadiusS = "4px";

export const cursorPointer = {
	cursor: "pointer",
};

export const noMargin = {
	margin: "0",
};

export const hoverTextColor = {
	":hover": {
		color: colors.hoverBlue,
	},
};

export const longLibraryNames = {
	[libraryNames?.PATENT]: "Patent",
	[libraryNames?.TRADEMARK]: "Trademark",
	[libraryNames?.COPYRIGHT]: "Copyright",
	[libraryNames?.TRADE_SECRET]: "Trade Secret",
	[libraryNames?.ANTITRUST]: "Antitrust",
	[libraryNames?.SECURITIES]: "Securities",
	[libraryNames?.PROFILE]: "Special Cases",
	[libraryNames?.OMNIBUS]: "Omnibus",
	[libraryNames?.UPC]: "Unified Patent Court",
};
